export default __webpack_public_path__ + "static/media/image.intelegenza-hub-pvt-ltd.cebbe4de.png";